/* eslint-disable spellcheck/spell-checker */

import { CONFIG as INAPP_CONFIG } from './versions/inapp';
import { CONFIG as RESCUETIME_ONBOARDING_CONFIG } from './versions/rescuetime-onboarding';
import { CONFIG as DEFAULT_CONFIG } from './versions/default';

export const VERSIONS: Record<string, any> = {
  inapp: {
    config: INAPP_CONFIG,
    addPanelItemConfigs: {
      in_app_action: {
        showPopover: true,
        popover: {
          title: 'In-app messages are here!',
          description: 'Click and drag to include in-app messages in your cross-channel campaign.',
        },
      },
    },
  },

  'rescuetime-onboarding': {
    config: RESCUETIME_ONBOARDING_CONFIG,
    addPanelItemConfigs: {},
  },

  default: {
    config: DEFAULT_CONFIG,
    addPanelItemConfigs: {},
  },
};

export function getConfig(version?: string | null) {
  if (version == null) {
    return VERSIONS.default;
  }

  return VERSIONS[version] ?? VERSIONS.default;
}
